import type { InternalSubtaskListLayoutColumn } from '../../types/changes';
import {
  fieldLabelByColumnId,
  INTERNAL_SUBTASK_CORE_COLUMN_OPTIONS,
  type InternalSubtaskTableColumnId,
} from './changeInternalSubtaskTableColumns';

const CORE_MAP: Record<string, InternalSubtaskTableColumnId> = {
  'core:title': 'title',
  'core:group_name': 'group_name',
  'core:status': 'status',
  'core:member': 'member',
  'core:task_type': 'task_type',
  title: 'title',
  group_name: 'group_name',
  status: 'status',
  member: 'member',
  task_type: 'task_type',
};

function resolveLayoutColumnLabel(
  item: InternalSubtaskListLayoutColumn,
  tableColumnId: InternalSubtaskTableColumnId,
): string {
  const canonical = fieldLabelByColumnId(tableColumnId, INTERNAL_SUBTASK_CORE_COLUMN_OPTIONS);
  const raw = (item.label || '').trim();
  if (!raw || raw === item.column_key || raw === tableColumnId) {
    return canonical;
  }
  return raw;
}

export type InternalSubtaskListLayoutColumnView = {
  columnKey: string;
  label: string;
  tableColumnId: InternalSubtaskTableColumnId | `preset:${string}`;
};

export function layoutColumnsFromApi(
  columns: InternalSubtaskListLayoutColumn[],
): InternalSubtaskListLayoutColumnView[] {
  return columns
    .filter((item) => item.is_visible)
    .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
    .map((item) => {
      const core = CORE_MAP[item.column_key];
      if (core) {
        return {
          columnKey: item.column_key,
          label: resolveLayoutColumnLabel(item, core),
          tableColumnId: core,
        };
      }
      if (item.column_key.startsWith('preset:')) {
        return {
          columnKey: item.column_key,
          label: item.label,
          tableColumnId: item.column_key as `preset:${string}`,
        };
      }
      return {
        columnKey: item.column_key,
        label: item.label,
        tableColumnId: 'title',
      };
    });
}
